<template>
  <!-- <b-dialog :mask="true" :mshow="true" :maskOpacity="0.8"> -->
    <div class="client-item-box video-pop-box" :data-trackdata="tData">
      <div class="video-pop" :class="data.wrapPopIndex">
        <beast-video
          ref="popVideo"
          :wrap="data.wrapPopIndex"
          :width="videoWidth"
          :height="videoHeight"
          :poster="data.poster"
          :autoplay="true"
          :source="data.source"
          :controls="data.controls"
          :videoFormat="data.videoFormat"
          :muted="data.muted"
          :radius="radius"
          :playVideo="true"
        />
      </div>
      <div class="close-box" @click="closeAction">
        <div class="close"></div>
      </div>
    </div>
  <!-- </b-dialog> -->
</template>

<script>
import { getClientWidth, getClientHeight } from '../lib/util.js'

import BDialog from '@/components/dialog'
import beastVideo from '@/components/video'

const clientWidth = getClientWidth()
const clientHeight = getClientHeight()

export default {
  name: 'video-pop',
  props: ['data', 'radius'],
  components: {
    BDialog,
    beastVideo
  },
  data () {
    console.log(this.data, "video pop data")
    return {
      videoWidth: parseInt(clientWidth) || 300,
      videoHeight: parseInt(clientHeight*0.8) || 600,
      tData: JSON.stringify(this.data.trackData || {})
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    closeAction () {
      this.$emit('close')
    },
  }
}
</script>

<style lang="stylus" scoped>
@import '../../common/styl/global.styl'
  .video-pop-box
    position fixed
    width 100%
    height 100%
    left 0
    top 0
    background rgba(0, 0, 0, 1)
    z-index 6666
    .video-pop
      width 100%
      position absolute
      left 50%
      top 50%
      transform translate(-50%, -50%)
  .close-box
    position absolute
    top rem(20)
    left rem(20)
    width rem(30)
    height rem(30)
    .close
      position absolute
      top 50%
      left 50%
      width rem(22)
      height rem(2)
      background #ffffff
      margin 0 auto
      transform translateX(-50%) translateY(-50%) rotateZ(45deg)
      &:after
        content ""
        background #ffffff
        display block
        width rem(22)
        height rem(2)
        position absolute
        top 0
        left 0
        transform rotateZ(90deg)

</style>



// WEBPACK FOOTER //
// video-pop.vue?1c90d8be